import './scripting-view.component.ajscss';

import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IScriptArgumentService } from '@agent/core/phone/script-argument/script-argument.service';
import { ICustomerCardsDeprecatedService } from '@commons/customer/customer-cards-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions, ILogService, ISCEService, isDefined, ITemplateRequestService } from 'angular';

import { Booking, BookingStatus, ChannelType, Civility, Customer, CustomerAddress, User } from '@contact/upgrade';

import templateUrl from './scripting-view.component.ajs.html';

const MODULE_NAME = 'contactScriptingView';
const SELECTOR_SPECIAL_CHARS = '#;&,.+*~\':"!^$[](){}=>|/';

class ScriptingViewCtrl implements IComponentController {
  public name = MODULE_NAME;
  public htmlPage: any = '';
  private pageUrl: string = '';
  private stepAgentScripting: string[] = [];
  private currentStep: number = 0;
  private customerCard: Customer | undefined;
  private customerAddresses: CustomerAddress[];
  private assignedCsr: User | undefined;
  private isInitialisated: boolean = false;

  private PREFIX: string = '/scripting-agent-generated/';
  private EMPTY_DATA: string = '[XXXXX]';

  constructor(
    private readonly $log: ILogService,
    private readonly $templateRequest: ITemplateRequestService,
    private readonly $sce: ISCEService,
    private readonly scriptArgument: IScriptArgumentService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly customerCardsDeprecatedService: ICustomerCardsDeprecatedService
  ) {}

  get hasNextPage(): boolean {
    if ($('#nextPage').length || $('.end').length) return true;
    return false;
  }

  goPreviousPage(): void {
    this.pageUrl = this.stepAgentScripting[--this.currentStep];
    this.loadHtmlPage();
  }

  goNextPage(): void {
    if ($('#nextPage').length) {
      this.pageUrl = this.PREFIX + $('#nextPage').val();
    } else {
      // our version of jQuery is TOO OLD to have escapeSelector (introduced in 3.0... in 2016) so we have to escape characters "by hand"
      // this.pageUrl = this.PREFIX + '#' + $.escapeSelector('nextPage-' + $('.end:checked').val().replace(/ /g, ''));
      let id = $('.end:checked').val();
      if (id) {
        // we escape all special "css selectors" characters one by one instead of using a regexp. It may be less efficient,
        // but between the special characters for string vs for regexp vs for selectors, we would have an absolute abomination on our hands
        SELECTOR_SPECIAL_CHARS.split('').forEach(c => (id = id.replace(c, '\\' + c)));
        this.pageUrl = this.PREFIX + $('#nextPage-' + id.replace(/ /g, '')).val();
      }
    }
    this.loadHtmlPage();
    this.currentStep++;
  }

  getScriptAgent(contact: Booking, customerCard: Customer | undefined, addresses: CustomerAddress[]) {
    // Get client information
    if (!!customerCard) {
      this.customerCard = customerCard;
      if (customerCard.assignedCsrId) {
        this.customerCardsDeprecatedService.getCsrName(customerCard.assignedCsrId).then(user => (this.assignedCsr = user));
      } else {
        this.assignedCsr = undefined;
      }
    }
    this.customerAddresses = addresses;
    // Load script url
    this.scriptArgument.getScriptAgent(contact).then(url => {
      this.pageUrl = url;
      this.loadHtmlPage();
    });
  }

  loadHtmlPage() {
    // Replace keyWord by user information
    if (!this.pageUrl || this.pageUrl === '') {
      return;
    }

    this.$templateRequest(this.pageUrl).then(template => {
      this.htmlPage = this.$sce.trustAsHtml(this.replaceKeysByValues(template));
      this.stepAgentScripting[this.currentStep] = this.pageUrl;
    });
  }

  replaceKeysByValues(htmlTemplate: string): string {
    let phone1;
    let phone2;
    let phone3;
    let email;
    let dedicatedAgent;
    let civility;
    let externalId;
    let firstName;
    let lastName;

    // get data from customerCard
    if (!!this.customerCard) {
      for (let address of this.customerAddresses) {
        if (address.channel.type === ChannelType.MAIL && email == null) {
          email = address.uri;
        } else if (address.channel.type === ChannelType.PHONE) {
          if (phone1 == null) {
            phone1 = address.uri;
          } else if (phone2 == null) {
            phone2 = address.uri;
          } else if (phone3 == null) {
            phone3 = address.uri;
          }
        }
      }
      dedicatedAgent = this.assignedCsr && this.assignedCsr.firstname;
      civility = this.customerCard.civility === Civility.MR || this.customerCard.civility === Civility.MS;
      firstName = this.customerCard.firstname;
      lastName = this.customerCard.lastname;
      externalId = this.customerCard.externalId;
    }

    if (!!htmlTemplate) {
      htmlTemplate = htmlTemplate.replace(/\${CLIENT_SURNAME}/gm, lastName || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${CLIENT_NAME}/gm, firstName || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${GENDER}/gm, civility || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${PHONE1}/gm, phone1 || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${PHONE2}/gm, phone2 || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${PHONE3}/gm, phone3 || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${EMAIL}/gm, email || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${CLIENT_ID}/gm, externalId || this.EMPTY_DATA);
      htmlTemplate = htmlTemplate.replace(/\${AGENT}/gm, dedicatedAgent || this.EMPTY_DATA);
    }

    return htmlTemplate;
  }

  validateScript() {
    this.pageUrl = '';
    this.customerCard = undefined;
    this.htmlPage = '';
    this.currentStep = 0;
    this.isInitialisated = false;
  }

  $onInit(): void {
    // contact updated
    this.contactDeprecatedService
      .contactUpdated$()
      .pipe(ng1Destroy(this))
      .subscribe(contact => this.loadContactInfo(contact));

    // contact state event
    this.contactDeprecatedService
      .contactState$()
      .pipe(ng1Destroy(this))
      .subscribe(event => {
        if (event.state !== BookingStatus.CLOSED) {
          // Call begin, we get the script
          this.customerCardsDeprecatedService.getCustomerCards(event.contact).then(
            ([data]) => this.getScriptAgent(event.contact, data.customer, data.addresses),
            () => {
              this.$log.error('[Script Agent : No Customer card');
              this.getScriptAgent(event.contact, undefined, []);
            }
          );
        } else if (event.state === BookingStatus.CLOSED) {
          // Call ending, we sent the answers
          this.validateScript();
        }
      });
  }

  private loadContactInfo(updatedContact) {
    if (isDefined(updatedContact.channel) && updatedContact.channel.type === ChannelType.PHONE) {
      if (updatedContact.customerCard.isDefined()) {
        this.customerCard = updatedContact.customerCard.get();
      }
      if (!this.isInitialisated) {
        this.loadHtmlPage();
        this.isInitialisated = true;
      }
    }
  }
}

export class ScriptingView implements IComponentOptions {
  templateUrl = templateUrl;
  controller = [
    '$log',
    '$templateRequest',
    '$sce',
    'scriptArgument',
    'contactDeprecatedService',
    'customerCardsDeprecatedService',
    ScriptingViewCtrl,
  ];
}

export default MODULE_NAME;
